// extracted by mini-css-extract-plugin
export default {"skipLink":"skipLink---KQrtY","skipLink__icon":"skipLink__icon---ad60B"};